import {
	DOCUMENT_VIEWER_PERMISSIONS,
	PRELIMINARY_REPORT,
	FINAL_REPORT,
	STUDY_REPORT,
	TEMPLATE_MANAGER,
	MISC,
	VR_SETTING,
	RADPAIR_REPORT,
} from '../../consts/documentViewerPermissionTags';

export const createDocumentViewerPermissionsSlice = (set, get) => ({
	documentViewerPermissions: undefined,
	patientPermission: { read: true },

	// All permissions as state
	PRELIMINARY_REPORT_PERMISSION: {},
	FINAL_REPORT_PERMISSION: {},
	STUDY_REPORT_PERMISSION: {},
	TEMPLATE_MANAGER_PERMISSION: {},
	MISC_PERMISSION: {},
	DOCUMENT_VIEWER_PERMISSION: {},
	VR_SETTING_PERMISSION: {},
	RADPAIR_REPORT_PERMISSION: {},

	setDocumentViewerPermissions: permissions => {
		const { getPermission } = get();
		set({
			documentViewerPermissions: permissions,
			PRELIMINARY_REPORT_PERMISSION: getPermission(
				PRELIMINARY_REPORT,
				DOCUMENT_VIEWER_PERMISSIONS.PRELIMINARY_REPORTS
			),
			FINAL_REPORT_PERMISSION: getPermission(FINAL_REPORT, DOCUMENT_VIEWER_PERMISSIONS.FINAL_REPORTS),
			STUDY_REPORT_PERMISSION: getPermission(STUDY_REPORT, DOCUMENT_VIEWER_PERMISSIONS.STUDY_REPORTS),
			TEMPLATE_MANAGER_PERMISSION: getPermission(TEMPLATE_MANAGER, DOCUMENT_VIEWER_PERMISSIONS.TEMPLATE_MANAGER),
			MISC_PERMISSION: getPermission(MISC, DOCUMENT_VIEWER_PERMISSIONS.MISC),
			DOCUMENT_VIEWER_PERMISSION: getPermission(DOCUMENT_VIEWER_PERMISSIONS),
			VR_SETTING_PERMISSION: getPermission(VR_SETTING, DOCUMENT_VIEWER_PERMISSIONS.VR_SETTING),
			RADPAIR_REPORT_PERMISSION: getPermission(RADPAIR_REPORT, DOCUMENT_VIEWER_PERMISSIONS.RADPAIR_REPORT),
		});
	},

	setPatientPermission: permission => set({ patientPermission: permission }),

	getPermission: (permission, permissionType) => {
		const { documentViewerPermissions } = get();
		const defaultPermission = { ...permission };
		if (!documentViewerPermissions) {
			for (const [key] of Object.entries(defaultPermission)) {
				defaultPermission[key] = true;
			}
			return defaultPermission;
		}
		if (permissionType) {
			for (const [key] of Object.entries(defaultPermission)) {
				defaultPermission[key] = documentViewerPermissions?.[permissionType]?.[permission?.[key]]
					? documentViewerPermissions?.[permissionType]?.[permission?.[key]]?.read
					: true;
			}
		} else {
			for (const [key] of Object.entries(defaultPermission)) {
				defaultPermission[key] = documentViewerPermissions?.[permission?.[key]]
					? documentViewerPermissions?.[permission?.[key]]?.read
					: true;
			}
		}
		return defaultPermission;
	},

	resetDocumentViewerPermissionsStore: () =>
		set({
			documentViewerPermissions: undefined,
			patientPermission: { read: true },
			PRELIMINARY_REPORT_PERMISSION: {},
			FINAL_REPORT_PERMISSION: {},
			STUDY_REPORT_PERMISSION: {},
			TEMPLATE_MANAGER_PERMISSION: {},
			MISC_PERMISSION: {},
			DOCUMENT_VIEWER_PERMISSION: {},
			VR_SETTING_PERMISSION: {},
			RADPAIR_REPORT_PERMISSION: {},
		}),
});
